module.exports = __webpack_public_path__ + "img/loginLogo.89d9afd1.png";